import React from "react";
import { useLang } from "../../context/lang-context";

const LandingFeatures: React.FC = () => {
  const { t } = useLang();

  const features = [
    {
      icon: "far fa-thumbs-up",
      title: t("Fácil de Usar", "Easy to Use"),
      desc: t(
        "La app extremadamente amigable de Foo te ayudará a pedir tu comida mucho más rápido.",
        "Foo's extremely friendly app will help you order your food much faster."
      ),
    },
    {
      icon: "fas fa-utensils",
      title: t("Personaliza tu Pedido", "Customize Your Order"),
      desc: t(
        "¿No te gusta un ingrediente? Quítalo. Que nadie te haga comer algo que no quieres.",
        "Don't like an ingredient? Remove it. No one should make you eat something you don't want."
      ),
    },
    {
      icon: "fas fa-motorcycle",
      title: t("Envío o Para Llevar", "Delivery or Takeout"),
      desc: t(
        "Escoge entre envío a domicilio, para llevar o para comer en el restaurante.",
        "Choose between home delivery, takeout, or dine-in at the restaurant."
      ),
    },
  ];

  return (
    <section className="features-section" id="funciones">
      <div className="container">
        <h2 className="section-title text-center">
          {t("¿Qué puedes hacer con Foo?", "What can you do with Foo?")}
        </h2>
        <div className="row justify-content-center">
          {features.map((f, i) => (
            <div className="col-12 col-md-4 mb-4" key={i}>
              <div className="feature-card text-center">
                <div className="feature-icon">
                  <i className={`${f.icon} fa-2x`}></i>
                </div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingFeatures;
